import { forwardRef } from "react";
import { ReactComponent as MedalIcon } from "../../../assets/icons/medal-solid.svg";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const IconMedal = forwardRef<SVGSVGElement, SvgIconProps>(
  function IconMedal(props, ref) {
    return (
      <SvgIcon
        ref={ref}
        component={MedalIcon}
        inheritViewBox
        {...props}
        sx={{ padding: "2px", ...props.sx }}
      />
    );
  },
);

export default IconMedal;
